<style lang="less">
    .page-reorder {
        width: 290px;
        .pages-container {
            margin: 15px;
            max-height: 182px;
            overflow-y: auto;
            overflow-x: hidden;
            .all-pages {
                position: relative;
                overflow: hidden;
                .selected-page {
                    border-color: var(--themeHover) !important;
                }
                .hidden-page {
                    opacity: 0 !important;
                }
                .page-div {
                    cursor: pointer;
                    height: 38px;
                    width: 100%;
                    background-color: var(--bg-color-tertiary);

                    .page-border {
                        pointer-events: none;
                        height: 30px;
                        border-radius: 3px;
                        border: 1px solid #ddd;
                        line-height: 30px;
                        text-indent: 10px;
                        user-select: none;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                    &:nth-last-child(1) {
                        height: 30px;
                    }
                    &:hover {
                        border-color: var(--themeHover) !important;
                    }
                }
            }
        }
        .dialog-enter {
            margin-top: 12px;
            height: 40px;
            position: relative;
            .dialog-op {
                position: absolute;
                width: 78px;
                height: 29px;
                border: 1px solid #e5e5e5;
                border-radius: 3px;
                text-align: center;
                line-height: 28px;
                cursor: default;
                user-select: none;
                &:hover {
                    background-color: #e5e5e5;
                }
            }
            .dialog-ok {
                right: 100px;
            }
            .dialog-cancel {
                right: 15px;
            }
        }
    }
</style>

<i18n>
{
  "zh": {
    "modalTitle": "重新排序页"
  },
  "en": {
    "modalTitle": "Rearrange Pages"
  },
  "jp": {
    "modalTitle": "ページの順番を並べ替える"
  },
  "fr": {
    "modalTitle": "Réorganiser les Pages"
  },
  "de": {
    "modalTitle": "Seiten neu anlegen"
  },
  "es": {
    "modalTitle": "Reorganizar las página"
  },
  "pt": {
    "modalTitle": "Reajustar Páginas"
  },
  "it": {
    "modalTitle": "Riordina Pagine"
  },
  "tw": {
    "modalTitle": "重新排序頁"
  },
  "kr": {
    "modalTitle": "페이지 재정렬"
  }
}
</i18n>
<template>
    <Dialog class="page-reorder" :title="$t('modalTitle')" :mask="true" :showFooter="true" @ok="toReorder" @close="cancel">
        <div ref="pageContains" class="pages-container">
            <div ref="allPages" class="all-pages">
                <div
                    class="page-div"
                    @mousedown="mouseDown($event, item.id, index)"
                    :class="{ 'hidden-page': index === hiddenIdx }"
                    :data-idx="index"
                    v-for="(item, index) in pageNames"
                >
                    <div class="page-border" :class="{ 'selected-page': item.id === activedPageID }" v-text="item.name"></div>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    import Dialog from "./Dialog.vue";
    import { Component, Prop, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class PageReorder extends Vue {
        // 初始数据可以直接声明为实例的属性
        message: string = "Hello!";
        activedPageID: number = null;
        hiddenIdx: number = null;
        step: number = 0; // step 滑动的步长。
        dir: boolean = false; //滑动的方向。

        pageNames = [];
        startScroll(dir: boolean, step: number) {
            this.dir = dir;
            this.step = step;
            if (!window["PRScrollEvent"]) {
                let stepFunc = () => {
                    if (this.dir) {
                        (<HTMLElement>this.$refs.pageContains).scrollTop += this.step / 2;
                    } else {
                        (<HTMLElement>this.$refs.pageContains).scrollTop -= this.step / 2;
                    }
                };
                window["PRScrollEvent"] = setInterval(stepFunc, 50);
            }
        }
        mouseDown(event, id: number, idx: number) {
            this.activedPageID = id;
            let moveFlag = false;
            let target = event.target;
            let parent = target.parentNode;
            let parentContainer = parent.parentNode;
            let PH = parent.offsetHeight;
            let PCH = parentContainer.offsetHeight;
            let y = event.offsetY;
            let cloneNode;
            document.onmousemove = (e) => {
                let moveTarget = e.target as HTMLElement;
                if (!parentContainer.contains(moveTarget)) {
                    return;
                }
                let PCTop = parentContainer.scrollTop;
                let topOffset = moveTarget.offsetTop + e.offsetY - PCTop;
                if (PH > PCH) {
                    //可以滚动
                    if (topOffset < 20 || topOffset > PCH - 20) {
                        if (topOffset < 20 && PCTop !== 0) {
                            this.startScroll(false, 20 - topOffset);
                        } else if (topOffset > PCH - 20 && PCTop !== PH - PCH) {
                            this.startScroll(true, 20 - (PCH - topOffset));
                        }
                    }
                }

                if (moveFlag) {
                    let index = parseInt(moveTarget.dataset.idx);
                    let dy = moveTarget.offsetTop + e.offsetY - y;
                    cloneNode.style.top = dy + "px";
                    if (this.hiddenIdx != index) {
                        let list = this.pageNames.splice(this.hiddenIdx, 1);
                        this.hiddenIdx = index;
                        this.pageNames.splice(this.hiddenIdx, 0, list[0]);
                    }
                } else if (e.offsetY !== event.offsetY) {
                    this.hiddenIdx = idx;
                    moveFlag = true;
                    cloneNode = target.cloneNode(true);
                    cloneNode.style.position = "absolute";
                    cloneNode.style.top = moveTarget.offsetTop + e.offsetY - y + "px";
                    cloneNode.style.zIndex = 1;
                    cloneNode.style.opacity = "";
                    cloneNode.style.height = "30px";
                    cloneNode.style.pointerEvents = "none";
                    cloneNode.style.borderColor = "#57a3f3";
                    parent.insertBefore(cloneNode, parent.firstChild);
                }
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                if (window["PRScrollEvent"]) {
                    clearInterval(window["PRScrollEvent"]);
                    window["PRScrollEvent"] = undefined;
                }
                if (moveFlag) {
                    parent.removeChild(cloneNode);
                    this.hiddenIdx = -1;
                }
            };
        }
        toReorder() {
            let idArr = this.pageNames.map((item) => {
                return item.id;
            });
            let view = window["_view"];
            view.reorderPages(idArr);
            this.cancel();
        }
        cancel() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        //生命周期
        mounted() {}

        created() {
            this.activedPageID = this.$store.state.page.activedPageID;
            this.pageNames = this.$store.state.page.pages.concat();
        }
    }
</script>
